/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 监管动态----统计信息
 */

import styles from './statistics.scss';
import React, { PureComponent } from 'react';
import cns from 'classnames';
import { Spin } from 'antd';
import { isNotEmpty } from '../../../../utils/util';
import NoData from '../../../common/noData/NoData';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { formatStaBarOption } from '../common/formatEchartOption';
import { quarterPublish } from '../../../../services/regulatoryStatistical';

export default class Statistics extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            barOption: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        quarterPublish().then(data => {
            this.setState({
                loading: false,
                barOption: formatStaBarOption(data)
            });
        });
    };

    render() {
        const { barOption, loading } = this.state;
        return (
            <div>
                <div className={cns('wrap-title', styles.title)}>近季度监管文件发布情况</div>

                <div className={styles.barChart}>
                    {
                        loading ?
                            <Spin /> :
                            isNotEmpty(barOption) ?
                                <BBDLineBar option={barOption}/> :
                                <NoData />
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/state/Statistics.jsx